import { render } from "./DashboardRegistrationsRowSkeleton.vue?vue&type=template&id=cffdefa6&scoped=true&ts=true"
import script from "./DashboardRegistrationsRowSkeleton.vue?vue&type=script&lang=ts"
export * from "./DashboardRegistrationsRowSkeleton.vue?vue&type=script&lang=ts"

import "./DashboardRegistrationsRowSkeleton.vue?vue&type=style&index=0&id=cffdefa6&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cffdefa6"]])

export default __exports__